<div id="layout-wrapper">
  <app-topbar (mobileMenuButtonClicked)="onToggleMobileMenu()" (settingsButtonClicked)="onSettingsButtonClicked()">
  </app-topbar>
  <app-sidebar></app-sidebar>
  <!-- ============================================================== -->
  <!-- Start right Content here -->
  <!-- ============================================================== -->
  <div class="main-content">
    <div class="page-content">
      <!-- <ngb-alert
        #selfClosingAlert
        type="success"
        (closed)="successMessage = ''"
        >{{ successMessage }}</ngb-alert
      > -->
      <router-outlet></router-outlet>
      <div class="chatbot-launcher" id="botIcon" (click)="getChatBot()" *ngIf="!isChatBotPage && custId=='GPBUM'">
        <div class="chatbot-icon">
          <i style="font-size: 30px;" [class.flip]="isFlipping" class="mdi mdi-robot"></i>
        </div>
      </div>
    </div>

    <app-footer></app-footer>
  </div>

  <app-rightsidebar></app-rightsidebar>
</div>
<!-- END layout-wrapper -->
